import React from 'react'

import style from './style.module.scss'

type Props = {
  component: any
  onChange: (field: { name: string }) => void
}

function StripeInput(props: Props) {
  const { component: Component, onChange } = props

  function handleChange(event) {
    const { elementType } = event
    onChange({ name: elementType })
  }

  return (
    <Component
      onChange={handleChange}
      options={{
        placeholder: '',
        style: {
          base: {
            color: '#4f4f4f',
            fontFamily: `'Nunito Sans', sans-serif`,
            fontSize: '14px',
          },
        },
        classes: {
          base: style.wrapper,
          invalid: style.invalid,
          focus: style.focus,
        },
      }}
    />
  )
}

export default StripeInput
